var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"truncate-cell-render"},[_c('span',{staticClass:"font-medium"},[_vm._v(" "+_vm._s(_vm.fullValue)+" ")]),_c('span',{staticClass:"text-regent-gray font-semibold"},[_vm._v(" "+_vm._s(_vm.symbol)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }